import { render, staticRenderFns } from "./SettingCamDetailsComponent.vue?vue&type=template&id=1959ca4c&scoped=true&"
import script from "./SettingCamDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./SettingCamDetailsComponent.vue?vue&type=script&lang=js&"
import style0 from "./SettingCamDetailsComponent.vue?vue&type=style&index=0&id=1959ca4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1959ca4c",
  null
  
)

export default component.exports